<div class="container">
  <h2>Details bearbeiten</h2>
  <div class="item-form-container">

    <form [formGroup]="waiterForm" (ngSubmit)="onSubmit()">

      <mat-form-field class="form-field">
        <input matInput placeholder="Vorname" formControlName="firstName" />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input matInput placeholder="Nachname" formControlName="lastName" />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input matInput placeholder="Straße" formControlName="street" />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input matInput placeholder="Hausnummer" formControlName="houseNumber" />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input matInput placeholder="PLZ" formControlName="zip" />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input matInput placeholder="Stadt" formControlName="city" />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input matInput placeholder="Land" formControlName="country" />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input matInput placeholder="Telefonnummer" formControlName="mobileNumber" />
      </mat-form-field>

      <mat-form-field class="form-field">
        <input matInput placeholder="E-Mail" formControlName="email" />
      </mat-form-field>

      <div class="form-field">
        <button mat-raised-button color="accent" type="submit" [disabled]="waiterForm.invalid">Speichern</button>
      </div>

    </form>
  </div>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Abbrechen</button>
  </mat-dialog-actions>
</div>
